module.exports = __webpack_public_path__ + "static/media/bulb-no-lift.819a8481.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Bulbs/bulb-no-lift.svg
// module id = 1590
// module chunks = 0